/**
 * @description Channel Partner source-connector catalog + flags (LYN-267)
 *
 * @dependencies apiClient
 * @notes Own-row only. No shop password.
 */

import apiClient from './apiClient';

export const listSourceConnectors = () =>
  apiClient.get('/channel-partner/source-connectors').then((r) => r.data);

export const saveSourceConnector = (connectorId, body) =>
  apiClient.put(`/channel-partner/source-connectors/${connectorId}`, body).then((r) => r.data);

export const uploadSourceConnectorLogo = (connectorId, file) => {
  const form = new FormData();
  form.append('logo', file);
  return apiClient
    .post(`/channel-partner/source-connectors/${connectorId}/logo`, form, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then((r) => r.data);
};

export const listSourceConnectorFlags = (connectorId) =>
  apiClient.get(`/channel-partner/source-connectors/${connectorId}/flags`).then((r) => r.data);

export const saveSourceConnectorFlag = (connectorId, body) =>
  apiClient.put(`/channel-partner/source-connectors/${connectorId}/flags`, body).then((r) => r.data);
